/*
 * Copyright (C) 2012-2025 Johan Legrand <johan.legrand@sync-in.com>
 * This file is part of Sync-in | The open source file sync and share solution
 * See the LICENSE file for licensing details
 */

export const USER_ROOM_PREFIX = 'uid_' as const
export const USERS_WS = {
  NAME_SPACE: '/',
  EVENTS: { ONLINE_STATUS: 'onlineStatus', ONLINE_USERS: 'onlineUsers', ONLINE_USER: 'onlineUser' }
} as const
